import { useEffect } from 'react';
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './configs/authConfig';
import EscalationForm from './components/EscalationForm';

function App() {
  const { instance, accounts, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress === InteractionStatus.None && accounts.length === 0) {
      instance.loginRedirect(loginRequest).catch(console.error);
    }
  }, [instance, accounts, inProgress]);

  const account = accounts[0];

  return (
    <div className="min-h-screen bg-gray-50">
      <AuthenticatedTemplate>
        <div className="flex justify-end px-4 py-2 text-xs text-gray-500">
          {account?.name} ({account?.username})
          <button
            onClick={() => instance.logoutRedirect()}
            className="ml-3 text-blue-600 hover:underline"
          >
            Sign out
          </button>
        </div>
        <EscalationForm
          userName={account?.name || ''}
          userEmail={account?.username || ''}
        />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className="flex items-center justify-center min-h-screen">
          <p className="text-gray-500">Signing in...</p>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default App;
